// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"650":"72494708","724":"bc96ae87","908":"9f101834"}[chunkId] + ".chunk.css";
};